import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export const FIELDS = {
  RELATED_EVENT_LINKS: 'relatedEventLinks',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.RELATED_EVENT_LINKS]: Yup.array().of(Yup.string().required(intl.formatMessage({ id: 'relatedEventLinkRequiredError' })))
    });
  }, [intl])
};